import type { PaywallConfig } from '../types/paywall.types';

/**
 * Paywall configuration defining pricing options and views
 * Supports multiple paywall variants with different pricing structures
 */
export const PAYWALL_CONFIG: PaywallConfig = {
    default_paywall: "v5",
    paywalls: [
        {
            id: "paddle_3_options_v2_weeks",
            billing: "paddle",
            default_view: "initial",
            prices: [
                {
                    id: "discount50_w1",
                    one_time_price_id: "com.shamruk.velvet.one2",
                    recurring_price_id: "com.shamruk.velvet.m50f1w",
                },
                {
                    id: "discount50_4w",
                    one_time_price_id: "com.shamruk.velvet.one7",
                    recurring_price_id: "com.shamruk.velvet.m50f4w",
                },
                {
                    id:"discount50_12w",
                    one_time_price_id: "com.shamruk.velvet.one15",
                    recurring_price_id: "com.shamruk.velvet.3m80f12w",
                },
                {
                    id:"discount65_w1",
                    one_time_price_id: "com.shamruk.velvet.one1",
                    recurring_price_id: "com.shamruk.velvet.m50f1w",
                },
                {
                    id:"discount65_4w",
                    one_time_price_id: "com.shamruk.velvet.one4",
                    recurring_price_id: "com.shamruk.velvet.m50f4w",
                },
                {
                    id:"discount65_12w",
                    one_time_price_id: "com.shamruk.velvet.one10",
                    recurring_price_id: "com.shamruk.velvet.3m80f12w",
                }
            ],
            views: [
                {
                    id:"initial",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}ROCK",
                        discount: 50,
                    },
                    options: [
                        {
                            title: "7-Days Plan",
                            price: "discount50_w1",
                            crossed_price: "${one_time_price_id}*2",
                            uncrossed_price: "${one_time_price_id}",
                            daily_price: "${one_time_price_id}/7",
                            daily_crossed_price: "${one_time_price_id}*2/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "monthly",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount50_4w",
                            crossed_price: "${one_time_price_id}/4*2",
                            uncrossed_price: "${one_time_price_id}/4",
                            daily_price: "${one_time_price_id}/28",
                            daily_crossed_price: "${one_time_price_id}/4*2/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "monthly",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount50_12w",
                            crossed_price: "${one_time_price_id}/12*2",
                            uncrossed_price: "${one_time_price_id}/12",
                            daily_price: "${one_time_price_id}/12/7",
                            daily_crossed_price: "${one_time_price_id}/12*2/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 3 months",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "button",
                                text: "Get my plan",
                                action: "open-checkout-popup",
                            }
                        ]
                    },
                    on_checkout_popup_close: [
                        {action: "show_discount_congratulations", discount_percent: 50},
                        {action: "switch_view", target_view: "extra_discount"}
                    ]
                },
                {
                    id:"extra_discount",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}PLUS",
                        discount: 67,
                    },
                    options: [
                        {
                            title: "7-Days Plan",
                            price: "discount65_w1",
                            crossed_price: "${one_time_price_id}*2*2",
                            uncrossed_price: "${one_time_price_id}",
                            daily_price: "${one_time_price_id}/7",
                            daily_crossed_price: "${one_time_price_id}*2*2/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "monthly",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount65_4w",
                            crossed_price: "${one_time_price_id}/4*2*1.75",
                            uncrossed_price: "${one_time_price_id}/4",
                            daily_price: "${one_time_price_id}/28",
                            daily_crossed_price: "${one_time_price_id}/4*2*1.75/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "monthly",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount65_12w",
                            crossed_price: "${one_time_price_id}/12*2*1.5",
                            uncrossed_price: "${one_time_price_id}/12",
                            daily_price: "${one_time_price_id}/12/7",
                            daily_crossed_price: "${one_time_price_id}/12*2*1.5/7",
                            pay_now: "${one_time_price_id}",
                            pay_later: "${recurring_price_id_discounted}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 3 months",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "button",
                                text: "Get my plan",
                                action: "open-checkout-popup",
                            }
                        ]
                    },
                }
            ]
        },
        {
            id: "paddle_3_options_v3_gur",
            billing: "paddle",
            default_view: "initial",
            prices: [
                {
                    id: "discount50_y",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.y130",
                },
                {
                    id: "discount50_m",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.m40",
                },
                {
                    id:"discount50_3m",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.3m60",
                },
            ],
            views: [
                {
                    id:"initial",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}ROCK",
                        discount: 50,
                    },
                    options: [
                        {
                            title: "1 Year Plan",
                            price: "discount50_y",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/365",
                            daily_crossed_price: "${recurring_price_id_original}/365",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 365,
                            pay_later_recurring_period: "annual",
                        },
                        {
                            title: "1 Month Plan",
                            price: "discount50_m",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/30",
                            daily_crossed_price: "${recurring_price_id_original}/30",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 30,
                            pay_later_recurring_period: "monthly",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "3 Months Plan",
                            price: "discount50_3m",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/90",
                            daily_crossed_price: "${recurring_price_id_original}/90",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 90,
                            pay_later_recurring_period: "every 3 months",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",
                            }
                        ]
                    }
                }
            ]
        },
        {
            id: "paddle_3_options_v4_gur",
            billing: "paddle",
            default_view: "initial",
            prices: [
                {
                    id: "discount50_y",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.y120",
                },
                {
                    id: "discount50_m",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.m30",
                },
                {
                    id: "discount50_w",
                    discount_id: "discount50",
                    recurring_price_id: "com.shamruk.velvet.w12",
                },
                {
                    id: "discount67_y",
                    discount_id: "discount67",
                    recurring_price_id: "com.shamruk.velvet.y120",
                },
                {
                    id: "discount67_m",
                    discount_id: "discount67",
                    recurring_price_id: "com.shamruk.velvet.m30",
                },
                {
                    id: "discount67_w",
                    discount_id: "discount67",
                    recurring_price_id: "com.shamruk.velvet.w12",
                },
            ],
            views: [
                {
                    id:"initial",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}ROCK",
                        discount: 50,
                    },
                    options: [
                        {
                            title: "1 Year Plan",
                            price: "discount50_y",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/365",
                            daily_crossed_price: "${recurring_price_id_original}/365",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 365,
                            pay_later_recurring_period: "annual",
                        },
                        {
                            title: "1 Month Plan",
                            price: "discount50_m",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/30",
                            daily_crossed_price: "${recurring_price_id_original}/30",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 30,
                            pay_later_recurring_period: "monthly",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "1 Week Plan",
                            price: "discount50_w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/7",
                            daily_crossed_price: "${recurring_price_id_original}/7",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 7 days",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",  // Express checkout (Apple Pay / Google Pay only)
                            }
                        ]
                    },
                    on_checkout_popup_close: [
                        {action: "show_discount_congratulations", discount_percent: 67},
                        {action: "switch_view", target_view: "extra_discount"}
                    ]
                },
                {
                    id:"extra_discount",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}PLUS",
                        discount: 67,
                    },
                    options: [
                        {
                            title: "1 Year Plan",
                            price: "discount67_y",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/365",
                            daily_crossed_price: "${recurring_price_id_original}/365",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 365,
                            pay_later_recurring_period: "annual",
                        },
                        {
                            title: "1 Month Plan",
                            price: "discount67_m",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/30",
                            daily_crossed_price: "${recurring_price_id_original}/30",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 30,
                            pay_later_recurring_period: "monthly",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "1 Week Plan",
                            price: "discount67_w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/7",
                            daily_crossed_price: "${recurring_price_id_original}/7",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 7 days",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",
                            }
                        ]
                    }
                }
            ]
        },
        {
            id: "v5",
            billing: "paddle",
            default_view: "initial",
            prices: [
                {
                    id: "discount50_4w1w",
                    discount_id: "discount50",
                    one_time_price_id: "one12",
                    recurring_price_id: "4w40f1w",
                },
                {
                    id: "discount50_4w",
                    discount_id: "discount50",
                    recurring_price_id: "4w40",
                },
                {
                    id: "discount50_12w",
                    discount_id: "discount50",
                    recurring_price_id: "12w80",
                },
                {
                    id: "discount67_4w1w",
                    discount_id: "discount67",
                    one_time_price_id: "one12",
                    recurring_price_id: "4w40f1w",
                },
                {
                    id: "discount67_4w",
                    discount_id: "discount67",
                    recurring_price_id: "4w40",
                },
                {
                    id: "discount67_12w",
                    discount_id: "discount67",
                    recurring_price_id: "12w80",
                },
            ],
            views: [
                {
                    id:"initial",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}ROCK",
                        discount: 50,
                    },
                    options: [
                        {
                            title: "1-Week Trial",
                            subtitle: "4-Week Plan",
                            price: "discount50_4w1w",
                            crossed_price: "${one_time_price_id_original}",
                            uncrossed_price: "${one_time_price_id_discounted}",
                            daily_price: "${one_time_price_id_discounted}/7",
                            daily_crossed_price: "${one_time_price_id_original}/7",
                            pay_now: "${one_time_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 4 weeks",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount50_4w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/28",
                            daily_crossed_price: "${recurring_price_id_original}/28",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "every 4 weeks",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount50_12w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/84",
                            daily_crossed_price: "${recurring_price_id_original}/84",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 12 weeks",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",  // Express checkout (Apple Pay / Google Pay only)
                            }
                        ]
                    },
                    on_checkout_popup_close: [
                        {action: "show_discount_congratulations", discount_percent: 67},
                        {action: "switch_view", target_view: "extra_discount"}
                    ]
                },
                {
                    id:"extra_discount",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}PLUS",
                        discount: 67,
                    },
                    options: [
                        {
                            title: "1-Week Trial",
                            subtitle: "4-Week Plan",
                            price: "discount67_4w1w",
                            crossed_price: "${one_time_price_id_original}",
                            uncrossed_price: "${one_time_price_id_discounted}",
                            daily_price: "${one_time_price_id_discounted}/7",
                            daily_crossed_price: "${one_time_price_id_original}/7",
                            pay_now: "${one_time_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 4 weeks",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount67_4w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/28",
                            daily_crossed_price: "${recurring_price_id_original}/28",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "every 4 weeks",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount67_12w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/84",
                            daily_crossed_price: "${recurring_price_id_original}/84",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 12 weeks",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",
                            }
                        ]
                    }
                }
            ]
        },        
        {
            id: "v6",
            billing: "paddle",
            default_view: "initial",
            prices: [
                {
                    id: "discount50_4w1w",
                    discount_id: "discount50",
                    one_time_price_id: "one9",
                    recurring_price_id: "4w30f1w",
                },
                {
                    id: "discount50_4w",
                    discount_id: "discount50",
                    recurring_price_id: "4w30",
                },
                {
                    id: "discount50_12w",
                    discount_id: "discount50",
                    recurring_price_id: "12w60",
                },
                {
                    id: "discount67_4w1w",
                    discount_id: "discount67",
                    one_time_price_id: "one9",
                    recurring_price_id: "4w30f1w",
                },
                {
                    id: "discount67_4w",
                    discount_id: "discount67",
                    recurring_price_id: "4w30",
                },
                {
                    id: "discount67_12w",
                    discount_id: "discount67",
                    recurring_price_id: "12w60",
                },
            ],
            views: [
                {
                    id:"initial",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}ROCK",
                        discount: 50,
                    },
                    options: [
                        {
                            title: "1-Week Trial",
                            subtitle: "4-Week Plan",
                            price: "discount50_4w1w",
                            crossed_price: "${one_time_price_id_original}",
                            uncrossed_price: "${one_time_price_id_discounted}",
                            daily_price: "${one_time_price_id_discounted}/7",
                            daily_crossed_price: "${one_time_price_id_original}/7",
                            pay_now: "${one_time_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 4 weeks",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount50_4w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/28",
                            daily_crossed_price: "${recurring_price_id_original}/28",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "every 4 weeks",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount50_12w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/84",
                            daily_crossed_price: "${recurring_price_id_original}/84",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 12 weeks",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",  // Express checkout (Apple Pay / Google Pay only)
                            }
                        ]
                    },
                    on_checkout_popup_close: [
                        {action: "show_discount_congratulations", discount_percent: 67},
                        {action: "switch_view", target_view: "extra_discount"}
                    ]
                },
                {
                    id:"extra_discount",
                    voucher: {
                        code: "${month_3_letter_uppercase}${year}PLUS",
                        discount: 67,
                    },
                    options: [
                        {
                            title: "1-Week Trial",
                            subtitle: "4-Week Plan",
                            price: "discount67_4w1w",
                            crossed_price: "${one_time_price_id_original}",
                            uncrossed_price: "${one_time_price_id_discounted}",
                            daily_price: "${one_time_price_id_discounted}/7",
                            daily_crossed_price: "${one_time_price_id_original}/7",
                            pay_now: "${one_time_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 7,
                            pay_later_recurring_period: "every 4 weeks",
                        },
                        {
                            title: "4-Week Plan",
                            price: "discount67_4w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/28",
                            daily_crossed_price: "${recurring_price_id_original}/28",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 28,
                            pay_later_recurring_period: "every 4 weeks",
                            badge: "MOST POPULAR",
                        },
                        {
                            title: "12-Week Plan",
                            price: "discount67_12w",
                            crossed_price: "${recurring_price_id_original}",
                            uncrossed_price: "${recurring_price_id_discounted}",
                            daily_price: "${recurring_price_id_discounted}/84",
                            daily_crossed_price: "${recurring_price_id_original}/84",
                            pay_now: "${recurring_price_id_discounted}",
                            pay_later: "${recurring_price_id_original}",
                            pay_later_in_days: 84,
                            pay_later_recurring_period: "every 12 weeks",
                        },
                    ],
                    below: {
                        items:[
                            {
                                type: "express-checkout",
                            }
                        ]
                    }
                }
            ]
        },        
    ]
};
